<template>
	<el-container class="friend-page" :class="{ 'h5-detail-open': h5DetailOpen }">
		<el-aside width="260px" class="friend-list-box">
			<div class="friend-list-header">
				<el-input class="search-text" size="small" placeholder="搜索手机号/ID/昵称" v-model="searchText" clearable>
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<div class="header-actions">
					<el-button plain class="icon-btn" icon="el-icon-refresh" title="刷新好友列表"
						:loading="refreshFriendLoading" @click="onRefreshFriendList"></el-button>
				</div>
				
				<add-friend :dialogVisible="showAddFriend" @close="onCloseAddFriend"></add-friend>
			</div>
			<div class="friend-list-items">
				<div class="top-item"  @click="onShowAddFriend()">
					<div class="top-item-avatar top-item-avatar--add">
						<i class="el-icon-plus"></i>
					</div>
					<div class="top-item-info">
						<div class="top-item-name">添加好友</div>
					</div>
				</div>
				<!-- 顶部列表: 新的朋友、ai机器人等 -->
				<div class="top-item" :class="showFriendReuqest ? 'active' : ''" @click="onClickNewFriend">
					<div class="top-item-avatar">
						<head-image :size="42" :url="require('@/assets/image/new_friend.png')">
							<div v-show="recvCount" class="unread-text">{{ recvCount }} </div>
						</head-image>
					</div>
					<div class="top-item-info">
						<div class="top-item-name">好友申请</div>
					</div>
				</div>
				
				<div class="divider"></div>
				<virtual-scroller
					class="friend-virtual-list"
					:items="friendListRows"
					:get-item-height="getFriendRowHeight"
					item-key="key"
				>
					<template v-slot="{ item }">
						<div v-if="item.rowType === 'index'" class="index-title">{{ item.letter }}</div>
						<friend-item
							v-else
							:friend="item.friend"
							:active="item.friend.id === activeFriend.id"
							@chat="onSendMessage(item.friend)"
							@delete="onDelFriend(item.friend)"
							@click.native="onActiveItem(item.friend)"
						>
						</friend-item>
					</template>
				</virtual-scroller>
			</div>
		</el-aside>
		<el-container v-if="showFriendReuqest" class="friend-box">
			<div class="friend-header">
				<div class="friend-header-left">
					<span class="h5-back" title="返回" @click="onH5Back"><i class="el-icon-arrow-left"></i></span>
					<span>好友申请</span>
				</div>
				<el-button size="mini" icon="el-icon-refresh" :loading="refreshFriendLoading" @click="onRefreshFriendList">刷新</el-button>
			</div>
			<friend-request class="request-list"></friend-request>
		</el-container>
		<el-container v-else class="friend-box">
			<div class="friend-header" v-show="userInfo.id">
				<div class="friend-header-left">
					<span class="h5-back" title="返回" @click="onH5Back"><i class="el-icon-arrow-left"></i></span>
					<span class="friend-header-name">
						<span :class="{ 'official-name': officialUserTag == 1 }">{{ userInfo.nickName }}</span>
						<official-tag :user-tag="officialUserTag" size="medium"></official-tag>
					</span>
				</div>
				<div class="header-actions">
					<el-button plain class="icon-btn" icon="el-icon-refresh" title="刷新好友列表"
						:loading="refreshFriendLoading" @click="onRefreshFriendList"></el-button>
				</div>
			</div>
			<div v-show="userInfo.id">
				<div class="friend-detail">
					<div class="friend-detail-avatar">
						<head-image :size="160" :name="userInfo.nickName" :url="userInfo.headImage" :radius="'10%'"
							@click.native="showFullImage()"></head-image>
					</div>
					<div>
						<div class="info-item">
							<el-descriptions title="好友信息" class="description" :column="1">
								<!-- <el-descriptions-item label="手机号">{{ userInfo.phone || userInfo.userName }}
									<el-tag v-if="userInfo.status == 1" size="mini" type="danger">已注销</el-tag>
								</el-descriptions-item> -->
								<el-descriptions-item label="用户昵称">
									<div class="nick-line">
										<span :class="{ 'official-name': officialUserTag == 1 }">{{ userInfo.nickName }}</span>
										<official-tag :user-tag="officialUserTag" :user-tag-img="officialUserTagImg" size="mini"></official-tag>
										<el-tag v-if="userInfo.isMuted" size="mini" type="warning">禁言中</el-tag>
									</div>
								</el-descriptions-item>
								<el-descriptions-item label="用户ID">{{ userInfo.id }}
								</el-descriptions-item>
								<el-descriptions-item label="手机号" v-if="userInfo.phone">{{ userInfo.phone || '-' }}</el-descriptions-item>
								<el-descriptions-item v-if="isFriend" class="remark" label="备注"
									:contentStyle="activeFriend.remarkNickName ? '' : 'color:#888;'">{{ activeFriend.showNickName }}
									<span class="icon iconfont icon-modify" @click="onEditRemark"></span>
								</el-descriptions-item>
								<el-descriptions-item label="性别">{{ userInfo.sex == 0 ? "男" : "女"
								}}</el-descriptions-item>
								<el-descriptions-item label="签名">{{ userInfo.signature || '-' }}</el-descriptions-item>
							</el-descriptions>
						</div>
						<div class="frient-btn-group">
							<el-button v-show="isFriend" icon="el-icon-position" type="primary"
								@click="onSendMessage()">发消息</el-button>
							<el-button v-show="isFriend" icon="el-icon-share" type="success"
								:loading="shareCardLoading" @click="onShareFriendCard">分享名片</el-button>
							<el-button v-if="canMute && !userInfo.canMuteUser" type="danger" plain :loading="muteLoading" @click="onToggleMute">
								{{ userInfo.isMuted ? '关闭禁言' : '开启禁言' }}
							</el-button>
							<el-button v-show="isFriend" icon="el-icon-delete" type="danger"
								@click="onDelFriend(userInfo)">删除好友</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-container>
		<friend-apply ref="applyRef"></friend-apply>
		<chat-selector ref="chatSel" title="分享名片"></chat-selector>
	</el-container>
</template>

<script>
import { peekFriendOnline } from '@/store/friendStore.js';
import ChatSelector from "../components/chat/ChatSelector.vue";
import HeadImage from "../components/common/HeadImage.vue";
import NoDataTip from '../components/common/NoDataTip.vue';
import OfficialTag from "../components/common/OfficialTag.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
import AddFriend from "../components/friend/AddFriend.vue";
import FriendApply from '../components/friend/FriendApply.vue';
import FriendItem from "../components/friend/FriendItem.vue";
import FriendRequest from '../components/friend/FriendRequest.vue';
import FriendRequestItem from "../components/friend/FriendRequestItem.vue";

export default {
	name: "friend",
	components: {
		FriendItem,
		FriendRequestItem,
		AddFriend,
		HeadImage,
		OfficialTag,
		NoDataTip,
		FriendApply,
		FriendRequest,
		ChatSelector,
		VirtualScroller
	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			refreshFriendLoading: false,
			activeFriend: {},
			userInfo: {},
			showFriendReuqest: false,
			shareCardLoading: false,
			muteLoading: false,
			friendsRenderVersion: null,
			onlineRenderVersion: 0
		}
	},
	watch: {
		'friendStore.friendsVersion': {
			immediate: true,
			handler(v) {
				if (this.friendsRenderVersion == null || (v - this.friendsRenderVersion) > 1) {
					this.friendsRenderVersion = v;
					return;
				}
				clearTimeout(this._friendRenderTimer);
				this._friendRenderTimer = setTimeout(() => {
					this.friendsRenderVersion = this.friendStore.friendsVersion;
				}, 250);
			}
		},
		'friendStore.onlineVersion': {
			immediate: true,
			handler(v) {
				if (!this.onlineRenderVersion) {
					this.onlineRenderVersion = v;
					return;
				}
				clearTimeout(this._onlineRenderTimer);
				this._onlineRenderTimer = setTimeout(() => {
					this.onlineRenderVersion = this.friendStore.onlineVersion;
				}, 800);
			}
		}
	},
	beforeDestroy() {
		clearTimeout(this._friendRenderTimer);
		clearTimeout(this._onlineRenderTimer);
	},
	methods: {
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onRefreshFriendList() {
			if (this.refreshFriendLoading) {
				return;
			}
			this.refreshFriendLoading = true;
			this.$store.dispatch("loadFriend").then(() => {
				this.$message.success("好友列表已刷新");
				if (this.activeFriend && this.activeFriend.id) {
					const latest = this.$store.getters.findFriend(this.activeFriend.id);
					if (latest && !latest.deleted) {
						this.onActiveItem(latest);
					} else {
						this.activeFriend = {};
						this.userInfo = {};
					}
				}
			}).finally(() => {
				this.refreshFriendLoading = false;
			});
		},
		friendMatchesKeyword(friend, keyword) {
			const kw = (keyword || '').trim().toLowerCase();
			if (!kw) {
				return true;
			}
			const fields = [
				friend.id,
				friend.phone,
				friend.userName,
				friend.nickName,
				friend.showNickName,
				friend.remarkNickName
			];
			for (let i = 0; i < fields.length; i++) {
				if (fields[i] != null && String(fields[i]).toLowerCase().indexOf(kw) >= 0) {
					return true;
				}
			}
			return false;
		},
		onActiveItem(friend) {
			this.activeFriend = friend;
			this.showFriendReuqest = false;
			this.loadUserInfo(friend.id);
		},
		onDelFriend(friend) {
			this.$confirm(`确认删除'${friend.nickName}',并清空聊天记录吗?`, '确认解除?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/friend/delete/${friend.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success("删除好友成功");
					this.$store.commit("removeFriend", friend.id);
					this.$store.commit("removePrivateChat", friend.id);
				})
			})
		},
		onAddFriend() {
			this.$refs.applyRef.open(this.userInfo)
		},
		onSendMessage(friend) {
			const target = friend && friend.id ? friend : this.activeFriend;
			if (!target || !target.id) {
				return;
			}
			let chat = {
				type: 'PRIVATE',
				targetId: target.id,
				showName: target.showNickName,
				headImage: target.headImage,
				userTag: target.userTag != null ? target.userTag : this.officialUserTag,
				userTagImg: target.userTagImg || this.officialUserTagImg,
			};
			this.$store.commit("openChat", {...chat, activeChat: true });
			this.$router.push("/home/chat");
		},
		onShareFriendCard() {
			if (!this.isFriend || !this.userInfo.id || this.shareCardLoading) {
				return;
			}
			const cardContent = JSON.stringify({
				userId: this.userInfo.id,
				nickName: this.userInfo.nickName || this.activeFriend.showNickName || '',
				headImage: this.userInfo.headImageThumb || this.userInfo.headImage || this.activeFriend.headImage || ''
			});
			this.$refs.chatSel.open((chats) => {
				this.shareCardLoading = true;
				const tasks = chats.map((chat) => {
					const isGroup = chat.type === 'GROUP';
					const data = {
						content: cardContent,
						type: this.$enums.MESSAGE_TYPE.USER_CARD,
						recvId: isGroup ? '' : chat.targetId,
						groupId: isGroup ? chat.targetId : ''
					};
					return this.$http({
						url: `/message/${chat.type.toLowerCase()}/send`,
						method: 'post',
						data
					}).then((m) => {
						m.selfSend = true;
						this.$store.commit("openChat", chat);
						this.$store.commit("insertMessage", [m, chat]);
						return true;
					}).catch(() => false);
				});
				Promise.all(tasks).then((results) => {
					const successCount = results.filter(Boolean).length;
					if (successCount === chats.length) {
						this.$message.success("分享成功");
						return;
					}
					if (successCount > 0) {
						this.$message.warning(`已成功分享${successCount}个会话，部分发送失败`);
						return;
					}
				}).finally(() => {
					this.shareCardLoading = false;
				});
			});
		},
		onEditRemark() {
			this.$prompt('请输入好友备注', '修改备注', {
				inputValue: this.activeFriend.showNickName,
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then((o) => {
				let data = {
					friendId: this.activeFriend.id,
					remarkNickName: o.value
				}
				this.$http({
					url: '/friend/update/remark',
					method: 'put',
					data: data
				}).then((friend) => {
					this.activeFriend = friend;
					this.$store.commit("updateChatFromFriend", friend);
					this.$store.commit("updateFriend", friend);
				})
			})
		},
		onClickNewFriend() {
			this.activeFriend = {};
			this.showFriendReuqest = true;
		},
		onH5Back() {
			this.activeFriend = {};
			this.userInfo = {};
			this.showFriendReuqest = false;
		},
		showFullImage() {
			if (this.userInfo.headImage) {
				this.$store.commit('showFullImageBox', this.userInfo.headImage);
			}
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.activeFriend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				friend.userTag = this.userInfo.userTag;
				friend.userTagImg = this.userInfo.userTagImg;
				if (this.userInfo.phone != null && this.userInfo.phone !== '') {
					friend.phone = this.userInfo.phone;
				}
				friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickName;
				this.$store.commit("updateChatFromFriend", friend);
				this.$store.commit("updateFriend", friend);
			}
		},
		onToggleMute() {
			if (!this.canMute || this.muteLoading || !this.userInfo.id) {
				return;
			}
			const isMuted = !this.userInfo.isMuted;
			this.muteLoading = true;
			this.$http({
				url: '/user/mute',
				method: 'put',
				data: {
					userId: this.userInfo.id,
					isMuted
				}
			}).then(() => {
				this.$set(this.userInfo, 'isMuted', isMuted);
				if (isMuted) {
					this.$message.success(`已禁言'${this.userInfo.nickName}'`);
				} else {
					this.$message.success(`已解除'${this.userInfo.nickName}'的禁言`);
				}
				this.loadUserInfo(this.userInfo.id);
			}).finally(() => {
				this.muteLoading = false;
			});
		},
		loadUserInfo(id) {
			// 获取好友用户信息
			this.$http({
				url: `/user/find/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		getFriendRowHeight(row) {
			return row && row.rowType === 'index' ? 28 : 60;
		}
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo;
		},
		friendStore() {
			return this.$store.state.friendStore;
		},
		friendListRows() {
			this.friendsRenderVersion;
			this.onlineRenderVersion;
			const map = new Map();
			const keyword = this.searchText || '';
			const friends = this.friendStore.friends || [];
			for (let i = 0; i < friends.length; i++) {
				const friend = friends[i];
				if (!friend || friend.deleted || !this.friendMatchesKeyword(friend, keyword)) {
					continue;
				}
				const letter = peekFriendOnline(friend.id).online ? '在线' : (friend.letter || '#');
				if (map.has(letter)) {
					map.get(letter).push(friend);
				} else {
					map.set(letter, [friend]);
				}
			}
			const keys = Array.from(map.keys()).sort((a, b) => {
				if (a == '#' || b == '#') {
					return b.localeCompare(a);
				}
				return a.localeCompare(b);
			});
			const rows = [];
			for (let i = 0; i < keys.length; i++) {
				const letter = keys[i];
				rows.push({ rowType: 'index', key: 'h-' + letter, letter });
				const list = map.get(letter);
				for (let j = 0; j < list.length; j++) {
					const friend = list[j];
					rows.push({ rowType: 'friend', key: friend.id, friend });
				}
			}
			return rows;
		},
		recvCount() {
			let requests = this.friendStore.requests || [];
			return requests.filter((req) => req.recvId == this.mine.id).length;
		},
		h5DetailOpen() {
			return this.showFriendReuqest || !!(this.userInfo && this.userInfo.id);
		},
		isFriend() {
			return this.$store.getters.isFriend(this.userInfo.id);
		},
		canMute() {
			if (!this.userInfo || !this.userInfo.id || !this.mine || !this.mine.id) {
				return false;
			}
			if (this.userInfo.id == this.mine.id) {
				return false;
			}
			return !!this.$store.getters.canMuteUser;
		},
		officialUserTag() {
			if (this.userInfo && this.userInfo.userTag != null) {
				return this.userInfo.userTag;
			}
			return this.activeFriend && this.activeFriend.userTag;
		},
		officialUserTagImg() {
			if (this.userInfo && this.userInfo.userTagImg) {
				return this.userInfo.userTagImg;
			}
			return this.activeFriend && this.activeFriend.userTagImg;
		}
	}
}
</script>

<style lang="scss">
.friend-page {
	height: 100%;

	.divider {
		border-bottom: 1px #ddd solid ;
		margin: 10px;
	}

	.friend-list-box {
		display: flex;
		flex-direction: column;
		background: var(--im-background);
		height: 100%;
		overflow: hidden;

		.friend-list-header {
			height: 50px;
			display: flex;
			align-items: center;
			padding: 0 8px;

			.header-actions {
				display: flex;
				align-items: center;
			}

			.icon-btn {
				padding: 5px !important;
				margin-left: 6px;
				font-size: 16px;
				border-radius: 50%;
			}
		}

		.friend-list-items {
			flex: 1;
			min-height: 0;
			display: flex;
			flex-direction: column;

			.top-item {
				height: 50px;
				display: flex;
				position: relative;
				padding: 5px 10px;
				align-items: center;
				white-space: nowrap;
				cursor: pointer;

				&:hover {
					background-color: var(--im-background-active);
				}

				&.active {
					background-color: var(--im-background-active-dark);
				}

				.top-item-avatar {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 42px;
					height: 42px;

					.unread-text {
						position: absolute;
						background-color: #f56c6c;
						right: -4px;
						top: -8px;
						color: white;
						border-radius: 30px;
						padding: 1px 5px;
						font-size: 10px;
						text-align: center;
						white-space: nowrap;
						border: 1px solid #f1e5e5;
					}
				}

				.top-item-avatar--add {
					border-radius: 10px;
					background: #ecf5ff;
					color: var(--im-color-primary);
					font-size: 20px;
				}

				.top-item-info {
					flex: 1;
					display: flex;
					flex-direction: column;
					padding-left: 10px;
					text-align: left;

					.top-item-name {
						font-size: var(--im-font-size);
						white-space: nowrap;
						overflow: hidden;
					}
				}
			}

			.friend-virtual-list {
				flex: 1;
				min-height: 0;
			}
		}

		.index-title {
			text-align: left;
			font-size: var(--im-larger-size-larger);
			padding: 5px 15px;
			color: var(--im-text-color-light);
		}
	}

	.friend-box {
		display: flex;
		flex-direction: column;

		.friend-header {
			height: 50px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 12px;
			font-size: var(--im-font-size-larger);
			border-bottom: var(--im-border);
			box-sizing: border-box;

			.friend-header-name {
				display: inline-flex;
				align-items: center;
				gap: 8px;
			}

			.header-actions {
				display: flex;
				align-items: center;
			}

			.icon-btn {
				padding: 5px !important;
				margin-left: 6px;
				font-size: 16px;
				border-radius: 50%;
			}
		}

		.request-list {
			flex: 1;
		}

		.friend-detail {
			display: flex;
			padding: 50px 30px 20px 30px;
			text-align: center;

			.friend-detail-avatar {
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 10px;
			}

			.info-item {
				margin-left: 20px;
				background-color: #ffffff;
				border: 1px #ddd solid;
			}

			.description {
				padding: 20px 20px 0 20px;

				.el-descriptions-item__label,
				.el-descriptions-item__content {
					vertical-align: middle;
					line-height: 21px;
				}

				.el-descriptions-item__content {
					align-items: center;
				}

				.nick-line {
					display: inline-flex;
					align-items: center;
					gap: 6px;
					height: 21px;
					line-height: 21px;

					.official-tag {
						height: 18px;
						width: auto;
					}

					.el-tag {
						margin: 0;
						height: 20px;
						line-height: 18px;
					}
				}

				.icon-modify {
					margin-left: 5px;
					cursor: pointer;
					color: var(--im-color-primary)
				}
			}
		}

		.frient-btn-group {
			text-align: left !important;
			padding: 20px;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 10px;
		}
	}
}
</style>